import React, { Component } from 'react';
import {
  Button,
  Table,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  Loading,
  TableCell,
  TableToolbar,
  DataTableSkeleton,
  Pagination,
} from 'carbon-components-react';
import View16 from '@carbon/icons-react/lib/view--filled/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import '../../scss/custom.scss';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  entitiesLabels,
  apioperation,
  STATUS,
} from '../../helpers/Constants';
import { api, registry } from '../../helpers/api/api';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { StatusTag } from '../../helpers/PageBreadCrumb';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import CAModal from './CAModal';
import IncidentRepository from '../../helpers/api/IncidentRepository';
import { Online, Offline } from '../common/OnLineOffLine';

export default class CAList extends Component {
  initialState = (props) => {
    let initialState = {
      idIncidentEdit: props.idIncidentEdit,
      idCar: props.idCar,

      //modal insert/edit
      keyModalCA: `modalCA_${new Date().getTime()}`,
      editModelCA: null,
      isEditModalCA: false,
      isOpenModalCA: false,
      isOpenDeleteModal: false,
      isDeleting: false,
      idToDelete: false,
      appType: null,
      appNationality: null,
      appStatus: null,
      car: props.car,
    };
    return initialState;
  };

  constructor(props) {
    super(props);
    //this.updateState = this.updateState.bind(this);
    // this.handleChangeCombo = this.handleChangeCombo.bind(this);
    this.state = {
      ...this.initialState(props),
    };
    //this.baseUrl = this.props.baseUrl;
    this.baseUrl = '/incident/' + this.state.idIncidentEdit + '/car/' + this.state.idCar + '/ca/';
  }

  baseUrl;

  componentDidMount() {
    this.getType();
    this.getCountry();
    this.getStatus();
  }

  getCAs = () => {
    return this.props.getCAs();
  };

  getStatus = () => {
    registry
      .getAll('status')
      .then((response) => {
        var data = response.data;
        data = data != null ? data.filter((item) => item.id != STATUS.Approved) : [];
        this.setState({
          appStatus: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, 'Loading status', 'ERROR')
        );
      })
      .finally(() => {});
  };

  getType() {
    registry
      .getAll('infooriginator')
      .then((response) => {
        var data = response.data;
        data = data != null ? data.map((item) => ({ id: item.name, name: item.name })) : [];
        this.setState({
          appType: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, 'Loading info originator', 'ERROR')
        );
      })
      .finally(() => {});
  }

  getCountry() {
    api
      .getAll('/country')
      .then((response) => {
        var data = response.data;
        this.setState({
          appNationality: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, 'Loading Country', 'ERROR')
        );
      })
      .finally(() => {});
  }

  detailCA = (id) => {
    this.props.history.push(this.baseUrl + id);
  };

  /**********CA********************/

  toggleModalCA = (open) => {
    this.setState({ isOpenModalCA: open });
  };

  addCA = () => {
    this.setState({ keyModalCA: `modalCA_${new Date().getTime()}` });
    this.setState({ isEditModalCA: false, isOpenModalCA: true, editModelCA: null });
  };

  editModalCA = (id) => {
    this.setState({ keyModalCA: `modalCA_${new Date().getTime()}` });
    let item = this.props.incidentCA.find((el) => el.id == id);
    this.setState({ editModelCA: item, isEditModalCA: true, isOpenModalCA: true });
  };

  handleSaveModalCA = (datiForm) => {
    //showNotification.warning("TODO Validazione su CAModal.js");

    if (!datiForm) return;

    this.setState({
      isSubmitted: true,
    });

    if (!this.state.isEditModalCA) datiForm.idIncident = this.state.idIncidentEdit;

    let method = this.state.isEditModalCA
      ? api.put(this.baseUrl, datiForm, datiForm.id)
      : api.post(this.baseUrl, datiForm);

    method
      .then((response) => {
        if (response.status == 200) {
          this.updateCacheList(datiForm).then(() => {
            this.getCAs();
          });

          this.setState({
            isOpenModalCA: false,
          });
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            `${entitiesLabels.INCIDENT} ${entitiesLabels.CA} 
                     ${getSuccess(
                       response.data.incidentCACode,
                       this.state.isEditModalCA ? apioperation.PUT : apioperation.POST
                     )}`
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(
            error,
            entitiesLabels.CA,
            this.state.isEditModalCA ? apioperation.PUT : apioperation.POST
          )
        );
      })
      .finally(() => {
        this.setState({
          isSubmitted: false,
        });
      });
  };

  updateCacheList = async (datiForm) => {
    if (!this.state.isEditModalCA) {
      datiForm.idIncidentCAR = this.state.idCar;
      datiForm.progressiveId = undefined;
      datiForm.sequence = undefined;
      datiForm.incidentCACode = null;
      datiForm.status = (this.state.appStatus || []).find((el) => el.id == datiForm.idStatus);
    }

    await IncidentRepository.updateCachedIncidentCA(
      this.state.idIncidentEdit,
      this.state.idCar,
      datiForm
    );
  };

  showLoading() {
    let show = this.state.isSubmitted;
    let descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active={true} withOverlay={true} description={descr} />;
    //return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  confirmDeleteCA = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  deleteItemCA = () => {
    let id = this.state.idToDelete;

    this.setState({
      isDeleting: true,
    });

    api
      .delete(this.baseUrl, id)
      .then((response) => {
        if (response.status == 200) {
          this.setState({
            idToDelete: null,
            isOpenDeleteModal: false,
          });
          this.onCloseConfirm();
          this.getCAs(id);
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.CA, apioperation.DELETE)
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CA, apioperation.DELETE)
        );
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        });
      });
  };
  /**********Fine CA********************/

  getStatusId = (idRow) => {
    let r = this.props.incidentCA.find((el) => el.id == idRow);
    return r && r.idStatus;
  };

  render() {
    const rows = this.props.incidentCA || [];

    const CAModalProps = {
      key: this.state.keyModalCA,
      title: 'CA',
      editModel: this.state.editModelCA,
      isOpenModal: this.state.isOpenModalCA,
      isEditModal: this.state.isEditModalCA,
      toggleModal: this.toggleModalCA,
      save: this.handleSaveModalCA,
      car: this.props.car,
      appType: this.state.appType,
      appNationality: this.state.appNationality,
      appStatus: this.state.appStatus,
      // appDirectCause: this.state.appDirectCause,
      // appRootCause: this.state.appRootCause,
      // appDirectCauseSubCategory: this.state.appDirectCauseSubCategory,
      // appRootCauseSubCategory: this.state.appRootCauseSubCategory,
    };

    const getNameCAById = (id) => {
      if (id == null) return '';
      let element = rows.find((el) => el.id == id);
      return element && element.owner && element.status
        ? `${element.owner.fullname} - ${element.dueDate} - ${element.status.caManagementName}`
        : '';
    };

    const confirmDelProps = () => ({
      idToDelete: this.state.idToDelete,
      nameItem: getNameCAById(this.state.idToDelete),
      isDeleting: this.state.isDeleting,
      open: this.state.isOpenDeleteModal, //open state
      onCloseConfirm: this.onCloseConfirm, //no click
      deleteItem: this.deleteItemCA, //yes click fn()
    });
    const paginationProps = () => ({
      page: this.props.currentPage || 1,
      totalItems: this.props.rowCount || 0,
      pageSize: this.props.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.props.handleChangePaging,
    });
    const colSpan = 6;
    //partial page
    return (
      <>
        <ConfirmAlertCustom {...confirmDelProps()} />
        <div className="bx--row container-page">
          {this.showLoading()}
          <div className="bx--col-lg-12 bx--col-md-12 container-page">
            <div>
              <h3 className="title--medium--expressive">CA</h3>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-12 container-page">
                <TableToolbar>
                  <h3 className="title--medium max-width"></h3>
                  {this.props.isDisabled ||
                  this.props.statusCar > 2 ||
                  this.props.statusIncident > 2 ? null : (
                    <Button onClick={() => this.addCA()} renderIcon={Add16}>
                      Add new
                    </Button>
                  )}
                </TableToolbar>

                <TableContainer className="bx--grid--full-width">
                  {this.props.isLoading ? (
                    <DataTableSkeleton headers={[]} rowCount={10} zebra={false} compact={false} />
                  ) : (
                    <Table>
                      <TableHead className="colorgray">
                        <TableRow>
                          <TableHeader>Owner</TableHeader>
                          <TableHeader>Owner Type</TableHeader>
                          <TableHeader>Due Date</TableHeader>
                          <TableHeader>Status</TableHeader>
                          <TableHeader className="align-center">Actions</TableHeader>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows == null || rows.length == 0 ? (
                          <NoRecordsPlaceholder labelText="No Records" colSpan={colSpan} />
                        ) : (
                          rows.map((item, index) => (
                            <TableRow key={'row_' + item.id}>
                              <TableCell key={'cell_fullname_' + item.id}>
                                {item.owner && item.owner.fullname}
                              </TableCell>
                              <TableCell key={'cell_type_' + item.id}>
                                {item.owner && item.owner.type}
                              </TableCell>
                              <TableCell key={'cell_dueDate_' + item.id}>
                                {' '}
                                {switchDateFormat(item.dueDate, 'date')}
                              </TableCell>
                              <TableCell key={'cell_status_' + item.id}>
                                <StatusTag value={item.status && item.status.caManagementName} />
                              </TableCell>
                              <TableCell
                                key={'action-' + item.id}
                                className="tableActions align-center"
                              >
                                <div>
                                  <Online>
                                    <Button
                                      onClick={() => this.detailCA(item.id)}
                                      size="small"
                                      renderIcon={View16}
                                      iconDescription="Detail"
                                      kind="ghost"
                                    />
                                  </Online>
                                  {this.props.isDisabled ? null : (
                                    <>
                                      <Button
                                        onClick={() => this.editModalCA(item.id)}
                                        size="small"
                                        renderIcon={Edit16}
                                        iconDescription="Edit"
                                        kind="ghost"
                                      />
                                      <Online>
                                        {this.getStatusId(item.id) == 1 && (
                                          <Button
                                            onClick={() => this.confirmDeleteCA(item.id)}
                                            size="small"
                                            renderIcon={Delete16}
                                            iconDescription="Delete"
                                            kind="ghost"
                                          />
                                        )}
                                      </Online>
                                    </>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  )}
                </TableContainer>
                <div className="footer-pagination">
                  <Pagination {...paginationProps()} />
                </div>
                <CAModal {...CAModalProps} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
